import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

export const submit = async (): Promise<void> => {
  const endpoint = '/api/integrations/submit';

  await withApiErrorHandler(endpoint, ApiErrorCode.ONBOARDING_INTEGRATIONS_SUBMIT_FAILED, () =>
    axiosInstance.post(endpoint)
  );
};
